import React, { useState } from 'react';
import { CheckCircle2, Lock, ShieldCheck, CreditCard, Zap, ArrowRight, Check, AlertTriangle } from 'lucide-react';
import { CTAButton } from '../components/ui/CTAButton';
export function CheckoutPage() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const basePrice = 9.99;
  const bump1Price = 4.99;
  const bump2Price = 4.99;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900 pb-12" data-id="element-203">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-4 px-4 sticky top-0 z-10" data-id="element-204">
        <div className="max-w-5xl mx-auto flex items-center justify-between" data-id="element-205">
          <div className="font-bold text-xl text-gray-900" data-id="element-206">
            Di Esto, <span className="text-rose-600" data-id="element-207">No Aquello™</span>
          </div>
          <div className="flex items-center gap-2 text-xs font-medium text-gray-500 bg-gray-100 px-3 py-1 rounded-full" data-id="element-208">
            <Lock className="h-3 w-3" data-id="element-209" />
            Pago Seguro 256-bit SSL
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-8 md:py-12" data-id="element-210">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-211">
          {/* LEFT COLUMN - Product Summary */}
          <div className="lg:col-span-5 space-y-6" data-id="element-212">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-213">
              <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-214">
                Estás a un paso de comunicarte con calma y seguridad
              </h1>
              <p className="text-gray-500 text-sm mb-6" data-id="element-215">
                Completa tu orden y recibe acceso inmediato a todo el material.
              </p>

              {/* Main Product */}
              <div className="flex gap-4 mb-6 pb-6 border-b border-gray-100" data-id="element-216">
                <div className="relative w-20 h-28 flex-shrink-0" data-id="element-217">
                  <img src="https://cdn.magicpatterns.com/uploads/6mHR95aYqiKteTwzfHgtr4/ChatGPT_Image_31_ene_2026,_03_36_32_p.m..png" alt="Ebook Cover" className="w-full h-full object-cover rounded-lg shadow-md" data-id="element-218" />
                  <div className="absolute -top-2 -right-2 bg-rose-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm" data-id="element-219">
                    OFERTA
                  </div>
                </div>
                <div data-id="element-220">
                  <h3 className="font-bold text-gray-900" data-id="element-221">
                    Di Esto, No Aquello™
                  </h3>
                  <p className="text-sm text-gray-500 mb-2" data-id="element-222">
                    Ebook Digital (PDF)
                  </p>
                  <div className="flex items-center gap-2" data-id="element-223">
                    <span className="font-bold text-rose-600 text-lg" data-id="element-224">
                      $9.99
                    </span>
                    <span className="text-gray-400 line-through text-sm" data-id="element-225">
                      $47.00
                    </span>
                  </div>
                </div>
              </div>

              {/* Bonuses */}
              <div className="space-y-3" data-id="element-226">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-227">
                  Incluye 3 Bonos GRATIS:
                </p>
                {[{
                name: 'Guía de Mensajes Calmantes™',
                val: '$19'
              }, {
                name: 'Qué Decir Cuando Él Se Cierra™ (PDF)',
                val: '$27'
              }, {
                name: 'Scripts de Emergencia™',
                val: '$15'
              }].map((bonus, i) => <div key={i} className="flex items-start gap-2 text-sm" data-id="element-228">
                    <CheckCircle2 className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" data-id="element-229" />
                    <span className="text-gray-700" data-id="element-230">
                      <span className="font-medium" data-id="element-231">{bonus.name}</span>
                      <span className="text-gray-400 text-xs ml-1" data-id="element-232">
                        (Valor {bonus.val})
                      </span>
                    </span>
                  </div>)}
              </div>

              {/* Instant Delivery Badge */}
              <div className="mt-6 bg-blue-50 text-blue-700 px-4 py-3 rounded-xl flex items-center gap-3 text-sm font-medium" data-id="element-233">
                <Zap className="h-5 w-5 text-blue-500" data-id="element-234" />
                Entrega inmediata por correo electrónico
              </div>
            </div>

            {/* Testimonial Snippet */}
            <div className="bg-rose-50 rounded-xl p-5 border border-rose-100 italic text-gray-600 text-sm relative" data-id="element-235">
              <div className="absolute -top-3 left-6 bg-white px-2 text-2xl leading-none text-rose-300" data-id="element-236">
                "
              </div>
              Literalmente salvó mi relación. Pensé que era exageración pero las
              frases funcionan como magia.
              <div className="mt-2 font-bold text-rose-700 not-italic text-xs" data-id="element-237">
                — Sofia M., Compradora verificada
              </div>
            </div>

            <div className="bg-purple-50 rounded-xl p-5 border border-purple-100 italic text-gray-600 text-sm relative" data-id="element-238">
              <div className="absolute -top-3 left-6 bg-white px-2 text-2xl leading-none text-purple-300" data-id="element-239">
                "
              </div>
              Antes me quedaba callada por miedo a pelear. Ahora sé exactamente
              qué decir y él me escucha. Lo mejor es que lo pude aplicar desde
              el primer día.
              <div className="mt-2 font-bold text-purple-700 not-italic text-xs" data-id="element-240">
                — Camila R., Compradora verificada
              </div>
            </div>

            <div className="bg-amber-50 rounded-xl p-5 border border-amber-100 italic text-gray-600 text-sm relative" data-id="element-241">
              <div className="absolute -top-3 left-6 bg-white px-2 text-2xl leading-none text-amber-300" data-id="element-242">
                "
              </div>
              Por $9.99 recibí más valor que en sesiones de terapia de pareja.
              Los scripts son oro puro. Ya se lo recomendé a tres amigas.
              <div className="mt-2 font-bold text-amber-700 not-italic text-xs" data-id="element-243">
                — Daniela P., Compradora verificada
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN - Checkout Form */}
          <div className="lg:col-span-7 space-y-5" data-id="element-244">
            {/* Order Bump 1 */}
            <div className={`
                border-2 rounded-2xl p-4 transition-all duration-300 relative overflow-hidden
                ${bump1 ? 'border-rose-500 bg-rose-50/30' : 'border-dashed border-gray-300 bg-gray-50 hover:border-rose-300'}
              `} data-id="element-245">
              {bump1 && <div className="absolute top-0 right-0 bg-rose-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-246">
                  AGREGADO ✓
                </div>}
              <label className="flex gap-4 cursor-pointer select-none" data-id="element-247">
                <div className="pt-1" data-id="element-248">
                  <input type="checkbox" className="w-5 h-5 text-rose-600 rounded focus:ring-rose-500 border-gray-300" checked={bump1} onChange={e => setBump1(e.target.checked)} data-id="element-249" />
                </div>
                <div className="flex-1" data-id="element-250">
                  <div className="flex justify-between items-start mb-1" data-id="element-251">
                    <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-252">
                      Sí, quiero los 50 Textos Clave para Calmar Conflictos con
                      Él y Mantener la Paz
                    </span>
                    <span className="font-bold text-rose-600 ml-2 whitespace-nowrap" data-id="element-253">
                      $4.99
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-254">
                    <span className="text-red-500 font-bold" data-id="element-255">
                      ¡Oferta única!
                    </span>{' '}
                    Frases listas para usar cuando la conversación ya está tensa
                    y necesitas calmar el momento antes de que escale.
                  </p>
                </div>
              </label>
            </div>

            {/* Order Bump 2 */}
            <div className={`
                border-2 rounded-2xl p-4 transition-all duration-300 relative overflow-hidden
                ${bump2 ? 'border-amber-500 bg-amber-50/30' : 'border-dashed border-gray-300 bg-gray-50 hover:border-amber-300'}
              `} data-id="element-256">
              {bump2 && <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-257">
                  AGREGADO ✓
                </div>}
              <label className="flex gap-4 cursor-pointer select-none" data-id="element-258">
                <div className="pt-1" data-id="element-259">
                  <input type="checkbox" className="w-5 h-5 text-amber-600 rounded focus:ring-amber-500 border-gray-300" checked={bump2} onChange={e => setBump2(e.target.checked)} data-id="element-260" />
                </div>
                <div className="flex-1" data-id="element-261">
                  <div className="flex justify-between items-start mb-1" data-id="element-262">
                    <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-263">
                      Sí, quiero saber los Errores de Comunicación que Arruinan
                      Conversaciones
                    </span>
                    <span className="font-bold text-amber-600 ml-2 whitespace-nowrap" data-id="element-264">
                      $4.99
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed" data-id="element-265">
                    <span className="text-amber-600 font-bold" data-id="element-266">
                      ¡No te lo pierdas!
                    </span>{' '}
                    Descubre los errores más comunes que hacen que no te
                    escuchen y aprende cómo corregirlos al instante.
                  </p>
                </div>
              </label>
            </div>

            {/* Checkout Form */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8" data-id="element-267">
              <div className="flex items-center justify-between mb-6" data-id="element-268">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-269">
                  Información de Pago
                </h2>
                <div className="flex gap-1" data-id="element-270">
                  {['visa', 'mastercard', 'amex'].map(card => <div key={card} className="h-6 w-10 bg-gray-100 rounded border border-gray-200" data-id="element-271"></div>)}
                </div>
              </div>

              <form className="space-y-5" onSubmit={e => {
              e.preventDefault();
              window.location.hash = '#thank-you';
            }} data-id="element-272">
                <div className="space-y-4" data-id="element-273">
                  <div data-id="element-274">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-275">
                      Nombre Completo
                    </label>
                    <input type="text" required className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" placeholder="Tu nombre" data-id="element-276" />
                  </div>
                  <div data-id="element-277">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-278">
                      Correo Electrónico
                    </label>
                    <input type="email" required className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" placeholder="tucorreo@ejemplo.com" data-id="element-279" />
                    <p className="text-xs text-gray-500 mt-1" data-id="element-280">
                      Aquí enviaremos tus accesos inmediatamente.
                    </p>
                  </div>

                  <div className="pt-2" data-id="element-281">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-282">
                      Tarjeta de Crédito / Débito
                    </label>
                    <div className="relative" data-id="element-283">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-284">
                        <CreditCard className="h-5 w-5 text-gray-400" data-id="element-285" />
                      </div>
                      <input type="text" required className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5 pl-10" placeholder="0000 0000 0000 0000" data-id="element-286" />
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-4" data-id="element-287">
                      <input type="text" required placeholder="MM / AA" className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" data-id="element-288" />
                      <input type="text" required placeholder="CVC" className="w-full rounded-lg border-gray-300 shadow-sm focus:border-rose-500 focus:ring-rose-500 py-2.5" data-id="element-289" />
                    </div>
                  </div>
                </div>

                {/* Order Summary */}
                <div className="border-t border-b border-gray-100 py-4 mt-6 space-y-2" data-id="element-290">
                  <div className="flex justify-between text-sm text-gray-600" data-id="element-291">
                    <span data-id="element-292">Ebook + 3 Bonos</span>
                    <span data-id="element-293">${basePrice.toFixed(2)}</span>
                  </div>
                  {bump1 && <div className="flex justify-between text-sm text-rose-600 font-medium" data-id="element-294">
                      <span data-id="element-295">50 Mensajes para Desescalar</span>
                      <span data-id="element-296">${bump1Price.toFixed(2)}</span>
                    </div>}
                  {bump2 && <div className="flex justify-between text-sm text-amber-600 font-medium" data-id="element-297">
                      <span data-id="element-298">Errores de Comunicación</span>
                      <span data-id="element-299">${bump2Price.toFixed(2)}</span>
                    </div>}
                  <div className="flex justify-between text-lg font-bold text-gray-900 pt-2 border-t border-gray-100" data-id="element-300">
                    <span data-id="element-301">Total a Pagar:</span>
                    <span data-id="element-302">${total.toFixed(2)}</span>
                  </div>
                </div>

                <CTAButton fullWidth className="w-full text-lg py-4 shadow-xl shadow-rose-200" data-id="element-303">
                  Completar Compra y Descargar Ahora
                </CTAButton>

                <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-gray-400 pt-2" data-id="element-304">
                  <div className="flex items-center gap-1" data-id="element-305">
                    <Lock className="h-3 w-3" data-id="element-306" /> Pago 100% Seguro
                  </div>
                  <div className="flex items-center gap-1" data-id="element-307">
                    <Zap className="h-3 w-3" data-id="element-308" /> Acceso Inmediato
                  </div>
                  <div className="flex items-center gap-1" data-id="element-309">
                    <ShieldCheck className="h-3 w-3" data-id="element-310" /> Garantía de 7 días
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="text-center text-xs text-gray-400 py-8 border-t border-gray-200 mt-8" data-id="element-311">
        <p data-id="element-312">
          © {new Date().getFullYear()} Di Esto, No Aquello™. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}